import { request, uploadFile, axiosInstance } from "../helper/axios_helper";

export const uploadFSD = (
  specName,
  comments,
  s3Path,
  documentType,
  category,
  fileType,
) => {
  return request("POST", "/api/auth/filespec/upload", {
    specName: specName,
    comments: comments,
    s3Path: s3Path,
    documentType: documentType,
    category: category,
    documentFileType: fileType,
  });
};

export const validateFSD = (specName) => {
  return request("GET", "/api/auth/filespec/validate", {
    file: specName,
  });
};

export const writeToDBOld = (specName, createSuite, documentType, file) => {
  let url = `/api/auth/filespec/write/${specName}/${createSuite}/${documentType}`;
  return uploadFile(url, file);
};

export const writeToDB = (
  specName,
  createSuite,
  documentType,
  file,
  dbName,
  query,
) => {
  let url = "/api/auth/filespec/write";
  return uploadFile(
    url,
    file,
    specName,
    documentType,
    createSuite,
    dbName,
    query,
  );
};

export const validateSpecName = (specName) => {
  return request("GET", `/api/auth/filespec/${specName}`);
};

// Fetch the original spec .xlsx bytes via the backend (works for both S3 and
// server-filesystem storage; authenticated, same-origin, no S3 CORS needed).
export const fetchSpecBytes = async (specName) => {
  const res = await axiosInstance.get(
    `/api/auth/filespec/file/${encodeURIComponent(specName)}`,
    { responseType: "arraybuffer" },
  );
  return res.data;
};

// ─── Edit + version history ───────────────────────────────────
// Both the inline editor and re-upload submit an .xlsx here.
export const editFSD = (file, requestBody) => {
  const formData = new FormData();
  formData.append("fileUpload", file);
  formData.append(
    "requestBody",
    new Blob([JSON.stringify(requestBody)], { type: "application/json" }),
  );
  return axiosInstance.post("/api/auth/filespec/edit", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getSpecVersions = (specName) =>
  request("GET", `/api/auth/filespec/versions/${encodeURIComponent(specName)}`);

export const downloadSpecVersion = async (id) => {
  const res = await axiosInstance.get(
    `/api/auth/filespec/version/file/${id}`,
    { responseType: "arraybuffer" },
  );
  return res.data;
};

export const restoreSpecVersion = (id) =>
  request("POST", `/api/auth/filespec/version/restore/${id}`);
